import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import { UserService } from '@forwardflow/services/UserService'

import useSWR from 'swr'

export const useGetUserCalenderInfo = (shouldFetch: boolean, organizationId?: string) => {
   const response = useSWR(
      shouldFetch ? (organizationId ? [QUERY_KEYS.USER_CALENDAR_INFO, organizationId] : [QUERY_KEYS.USER_CALENDAR_INFO]) : null,
      () => UserService.getUserCalenderInfo(),
      {
         shouldRetryOnError: false,
         revalidateOnMount: true,
      }
   )
   return {
      ...response,
      mutate: () => response.mutate(),
   }
}
